import { DEEP_LEVEL_CATEGORIES, DEEP_LEVEL_GROUPS, DEEP_LEVEL_APARTMENTS } from "./constants";

export default class NavigationApartmentsMobile {

    closeFunction = null;
    deepLevel = DEEP_LEVEL_CATEGORIES;
    selectedCategoryId = null;
    selectedCategoryName = null;

    constructor(closeFunction) {
        this.closeFunction = closeFunction;
        this.mainContainer = document.querySelector('.list-of-apartments-mobile');
        this.header = document.querySelector('.list-of-apartments-mobile__header');
        this.content = document.querySelector('.list-of-apartments-mobile__content');
        this.categoriesUL = this.content.querySelector('ul:first-child');
        this.contentCategoriesULs = this.content.querySelectorAll('ul[data-content-category-id]');
        this.contentGroupsULs = this.content.querySelectorAll('ul[data-content-group-id]');

        this.addIcons();
        this.prepareBackButton();
        this.prepareCloseButton();
        this.prepareLIs();
    }

    prepareBackButton = () => {
        const button = document.getElementById('buttonPrevLOA');

        button.addEventListener('click', () => {
            switch (this.deepLevel) {
                case DEEP_LEVEL_CATEGORIES:
                    this.closeFunction();
                    break;

                case DEEP_LEVEL_GROUPS:
                    this.deepLevel = DEEP_LEVEL_CATEGORIES;
                    this.header.querySelector('h3').innerText = this.header.querySelector('h3').dataset.baseTitle;
                    this.categoriesUL.classList.add('active');
                    [...this.contentCategoriesULs].forEach(ul => ul.classList.remove('active'));
                    break;

                case DEEP_LEVEL_APARTMENTS:
                    this.deepLevel = DEEP_LEVEL_GROUPS;
                    this.header.querySelector('h3').innerText = this.selectedCategoryName;
                    this.content.querySelector(`ul[data-content-category-id="${this.selectedCategoryId}"]`).classList.add('active');
                    [...this.contentGroupsULs].forEach(ul => ul.classList.remove('active'));
                    break;
            
                default:
                    break;
            }
        });
    }

    prepareCloseButton = () => {
        const button = document.getElementById('buttonCloseLOA');

        button.addEventListener('click', () => {
            this.closeFunction();
        });
    }

    prepareLIs = () => {
        this.prepareCategoriesLIs();
        this.prepareContentsLIs();
    }

    prepareCategoriesLIs = () => {
        this.categoriesUL.querySelectorAll('li:not(:has(a))').forEach(li => {
            li.addEventListener('click', () => {
                const categoryID = this.selectedCategoryId = li.dataset.categoryId;
                const title = this.selectedCategoryName = li.innerText;
                const content = this.content.querySelector(`ul[data-content-category-id="${categoryID}"]`);

                this.deepLevel = DEEP_LEVEL_GROUPS;
                this.header.querySelector('h3').innerText = title;
                this.categoriesUL.classList.remove('active');
                content.classList.add('active');
            });
        });
    }

    prepareContentsLIs = () => {        
        [...this.contentCategoriesULs].forEach(ul => {
            ul.querySelectorAll('li:not(:has(a))').forEach(li => {
                li.addEventListener('click', () => {
                    const groupID = li.dataset.groupId;
                    const title = li.innerText;
                    const content = this.content.querySelector(`ul[data-content-group-id="${groupID}"]`);
    
                    this.deepLevel = DEEP_LEVEL_APARTMENTS;
                    this.header.querySelector('h3').innerText = title;
                    ul.classList.remove('active');
                    content.classList.add('active');
                });
            });
        });
    }
    
    addIcons = () => {
        [this.categoriesUL, ...this.contentCategoriesULs].forEach(ul => {
            ul.querySelectorAll('li:not(:has(a))').forEach(li => {
                li.innerHTML = li.innerHTML + ` <img src="${this.mainContainer.dataset.arrowIconPath}">`;
            });

            ul.querySelectorAll('li:has(a)').forEach(li => {
                li.innerHTML = li.innerHTML + ` <img src="${this.mainContainer.dataset.homeIconPath}">`;
            });
        });
    }
}